<template>
  <section class="content" v-if="welcome">
    <h2 class="subtitle" v-if="welcomeTitle" v-html="welcomeTitle"></h2>
    <p id="welcomeText" v-html="welcome"></p>
  </section>
</template>

<script>
export default {
  computed: {
    welcomeTitle() {
      return this.$store.state.welcome_title;
    },
    welcome() {
      return this.$store.state.welcome;
    },
  },
};
</script>
